import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {AppStore} from "./state/AppStore";
import {metaSlice} from "./state/MetaSlice";
import {setupAnalytics} from "./analytics/setupAnalytics";

(async () => {
    try {
        const response = await fetch("config.json");
        const config = await response.json();
        setupAnalytics(config.tracker);
        AppStore.dispatch(metaSlice.actions.settings(config));
        ReactDOM.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
            document.getElementById('root')
        );
    }
    catch(error) {
        AppStore.dispatch(metaSlice.actions.setError(error.message));
    }
})();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
